module.exports = __webpack_public_path__ + "static/img/57.8d9c69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/57.png
// module id = hkPY
// module chunks = 0